import type {RouteLocationNormalized, Router} from 'vue-router';
import type {UserModule} from '@/types';
import {retryMissingDefaultRouteComponent} from '@/composables/routeComponentRecovery';

const hostnamePattern = /^(?=.{1,253}$)(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/i;

export const normalizeSourceHost = (value: unknown): string => {
    const input = Array.isArray(value) ? value[0] : value;
    if (typeof input !== 'string' || !input.trim()) return '';

    try {
        const candidate = input.includes('://') ? input : `https://${input}`;
        const hostname = new URL(candidate).hostname.toLowerCase().replace(/\.$/, '');
        return hostnamePattern.test(hostname) ? hostname : '';
    } catch {
        return '';
    }
};

export const viewerReferralRedirect = (to: RouteLocationNormalized) => {
    if (to.path !== '/') return;
    const host = normalizeSourceHost(to.query.host);
    if (!host) return;

    return {
        path: '/powered-by',
        query: {host},
        replace: true
    };
};

const redirectInitialReferral = (router: Router) => {
    const redirect = viewerReferralRedirect(router.currentRoute.value);
    if (redirect) void router.replace(redirect);
};

export const install: UserModule = ({isClient, router}) => {
    if (!isClient) return;

    const appVersion = import.meta.env.VITE_APP_VERSION || 'unknown';
    router.onError((error, to) => {
        if (to.path !== '/powered-by') return;

        retryMissingDefaultRouteComponent(
            error,
            to.path,
            appVersion,
            window.sessionStorage,
            () => window.location.reload(),
        );
    });
    router.beforeEach(viewerReferralRedirect);
    redirectInitialReferral(router);
};
